<template>
    <div>
        <div class="nav">
            <h2 v-if="pageType == 'home'" @click="getInfo(solutionItem)" class="cursPoint">{{ solutionItem.item.name }}</h2>
            <h2 v-else>{{ solutionItem.item.name }}</h2>
            <div class="nav-item">
                <div class="nav-tit">
                    <div v-for="(ParkItem1, index) in solutionItem.item.item1" :key="index + 'item'" class="tit-item">
                        <div>{{ ParkItem1 }}</div>
                    </div>
                </div>
                <div class="nav-tit">
                    <div v-for="(ParkItem2, index) in solutionItem.item.item2" :key="index + 'item'" class="tit-item">
                        <div>{{ ParkItem2 }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav" v-if="solutionItem.bigData">
            <h2 style="color: black;font-size: 30px;">{{ solutionItem.bigData.name }}</h2>
            <div class="nav-item">
                <div :class="['nav-tit', solutionItem.bigData.bigDataCss]">
                    <div v-for="(bigDataItem1, index) in solutionItem.bigData.item1" class="tit-item"
                        :key="index + 'item'">
                        <img v-if="solutionItem.bigData.itemPic" :src="solutionItem.bigData.itemPic[index]">
                        <div>{{ bigDataItem1 }}</div>
                    </div>
                </div>
                <div class="nav-tit">
                    <div v-for="(bigDataItem2, index) in solutionItem.bigData.item2" :key="index + 'item'"
                        class="tit-item">
                        <div>{{ bigDataItem2 }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="solutionItem.parkImg" style="display: flex;" :class="[solutionItem.parkImgCss]">
            <div v-for="(parkImgItem, index) in solutionItem.parkImg" :key="index + 'parkItem'" class="SmartPark">
                <img :src="parkImgItem" alt="">
            </div>
        </div>
        <el-divider></el-divider>
    </div>
</template>

<script>
import { solutionOptions } from '@/view/solution.js'

export default {
    name: "pageContent",
    props: ['solutionItem', 'pageType'],
    data() {
        return {
            solutionOptions
        }
    },
    methods: {
        getInfo(val) {
            var rowData = val;
            sessionStorage.setItem("rowData", JSON.stringify(rowData));
            this.$router.push({
                name: "BuildingControl"
            });
        }
    }
};
</script>


<style scoped>
.cursPoint {
    /* 初始状态 */
    position: relative;
    top: 0;
    transition: transform 0.5s, color 0.5s, top 0.5s;
    cursor: default;
    color: #000;
    /* 初始颜色 */
}

.cursPoint:hover {
    cursor: pointer;
    transform: scale(1.1);
    /* 放大到1.1倍 */
    color: #2587e4;
    /* 悬停时的颜色 */
    top: -5px;
    /* 使用 relative 定位向上移动10px */
}

.content {
   width: 1340px;
    margin: auto;
}

.smartPark {
    width: 80%;
    margin: auto;
    margin-top: 30px;
}

.smartPark img {
    width: 100%;
}

.nav {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.nav h2 {
    font-size: 35px;
    color: #026ACB;
}

.nav-item {
    width: 78%;
    box-sizing: border-box;

}

.nav-tit {
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    font-size: 20px;
    color: #6f6f6f;
}

.SmartPark {
    display: flex;
    justify-content: space-between;
    margin: auto;
    height: 130px;
    width: 30%;
}

.SmartPark img {
    width: 100%;
}

.tit-item {
    font-size: 20px;
    color: #6f6f6f;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.bigDataCssImg {
    margin-bottom: 20px;
}

.bigDataCssImg img {
    width: 80px;
    height: 80px;
}

.imgListA {
    display: flex;
    flex-wrap: wrap;

}

.imgListA .SmartPark {
    width: 19%;
    margin-bottom: 10px;
}

.imgListB .SmartPark {
    width: 150px;
    height: 150px;
    display: flex;
    justify-content: space-around;
}

.imgListC {
    display: flex;
    flex-direction: column;
}

.imgListC .SmartPark {
    width: 100%;
    height: auto;
}
</style>